//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import deviceRecordMoudle from "./modules/deviceRecordMoudle";
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { querySelectDeviceRecordItem } from '@/api/api';
export default {
  name: "DeviceRecordList",
  mixins: [JeecgListMixin],
  components: {
    deviceRecordMoudle: deviceRecordMoudle
  },
  data: function data() {
    return {
      pagePath: '/om/device/record',
      pageTitle: '设备运维记录',
      // 表头
      columns: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: "center",
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        dataIndex: 'dataTime',
        colName: 'data_time',
        title: '填写时间',
        align: "center"
      }, {
        dataIndex: 'createBy_userName',
        colName: 'create_by',
        title: '创建人',
        align: "center"
      }, {
        title: '操作',
        dataIndex: 'action',
        align: "center",
        width: 120,
        scopedSlots: {
          customRender: 'action'
        }
      }]
    };
  },
  created: function created() {},
  computed: {},
  methods: {
    onDateDataTime: function onDateDataTime(value, dateArray) {
      this.queryParam.dataTimeStart = dateArray[0];
      this.queryParam.dataTimeEnd = dateArray[1];
    },
    onToAdd: function onToAdd() {
      this.$refs.modalForm.add();
    },
    handleDetail: function handleDetail(record) {
      this.getRecordItem(Object.assign({}, record), true);
    },
    handleEdit: function handleEdit(record) {
      console.log('record', record);
      this.getRecordItem(Object.assign({}, record), false); // this.$refs.modalForm.edit(record, true)
    },
    getRecordItem: function getRecordItem(data, state) {
      var _this = this;

      querySelectDeviceRecordItem(data.id).then(function (res) {
        if (res.success) {
          var obj = {
            dataTime: data.dataTime,
            deviceRecordItemList: res.result
          };

          _this.$refs.modalForm.edit(data, obj, state);
        }
      });
    }
  }
};